import { FC } from 'react';
import classNames from 'classnames';

import { getFormattedCountdownDate, useCountdown } from 'hooks/useCountdown';

type PlaceBidModalCountdownProps = {
  endDate: string;
};

export const PlaceBidModalCountdown: FC<PlaceBidModalCountdownProps> = ({ endDate }) => {
  const countdown = useCountdown(endDate);
  const formattedCountdownDate = getFormattedCountdownDate(countdown, endDate);

  return (
    <div
      className={classNames('fs-12px text-uppercase riforma-medium letter-spacing-067', {
        'text-light': parseInt(countdown.days) >= 1 || countdown.hasEnded,
        'text-danger': parseInt(countdown.days) < 1 && !countdown.hasEnded
      })}
    >
      Ends in: {formattedCountdownDate}
    </div>
  );
};
